import { render, staticRenderFns } from "./paPayroll.vue?vue&type=template&id=5732a417&"
import script from "./paPayroll.vue?vue&type=script&lang=js&"
export * from "./paPayroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports